export default __webpack_public_path__ + "static/media/limb_big.3d718e5f.jpg";